import React, { useEffect, useState, Fragment } from "react";
import { Row, Col, Form, Button } from 'react-bootstrap'


export default function FeedbackPopup(props) {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        const shouldShow = Math.random() < 0.4;
        const alreadyAnswered = localStorage.getItem("feedbackAnswered");

        if (shouldShow && !alreadyAnswered) {
            setShowPopup(true);
        }

    }, []);
    function handleNext() {
        if(props.answer=="") { return false }
        props.handleNext()
    }

    function handleSkip() {
        props.handleNext()
    }

    return (<Fragment>
        {showPopup && (
            <div className="feedback-pop-main">
                <div className="feedback-pop">
                    <h3>QUICK FEEDBACK</h3>
                    <Form className="form">
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                            <Form.Label column >{props.step}) {props.feedbackQns[props.step - 1].question}</Form.Label>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                            <Col>
                                <Form.Control value={props.answer} onChange={props.handleChange} type="text" name="answer" />
                            </Col>
                        </Form.Group>
                    </Form>
                    <div className="feedback-buttons">
                        {props.step > 1 ?
                            <div className="feedback-button">
                                <Button onClick={props.handleFeedbackback}>Back</Button>
                            </div> : null}

                        <div className="feedNext-button">
                            {props.feedbackQns[props.step - 1].feedback_enable != 1 && props.answer == "" ?
                                <Button className="skip" onClick={handleSkip}>Skip</Button> : null}
                            <Button onClick={handleNext}>Next</Button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </Fragment>
    );
}
